export default __webpack_public_path__ + "static/media/ray-tracer.b2272846.png";